import React from "react";
import { Container } from "react-bootstrap";
import { Outlet } from "react-router";

import { ErrorBoundary } from "@/components/ErrorBoundary";
import { JobTrackerNav } from "./JobTrackerNav";
import { withJob, WithJobProps } from "./components/withJob";
import { JobTrackerPage } from "./JobTrackerPage";

const JobTrackerLayout: React.FC<WithJobProps> = ({ job }) => {
  return (
    <div className="d-flex h-100">
      <div className="flex-grow-0 flex-shrink-0 bg-secondary-subtle py-3 me-3">
        <JobTrackerNav job={job} />
      </div>
      <Container fluid className="flex-grow-1 overflow-y-auto py-3">
        <ErrorBoundary>
          <JobTrackerPage>
            <Outlet />
          </JobTrackerPage>
        </ErrorBoundary>
      </Container>
    </div>
  );
};

export default withJob(JobTrackerLayout);
